import { useEffect, useRef, useState } from 'react';

interface HelpImageProps {
  src?: string;
  alt: string;
  caption?: string;
  pendingId?: string;
}

export function HelpImage({ src, alt, caption, pendingId }: HelpImageProps) {
  const [open, setOpen] = useState(false);
  const closeRef = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    if (!open) return;

    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    closeRef.current?.focus();

    function onKeyDown(event: KeyboardEvent) {
      if (event.key === 'Escape') setOpen(false);
    }

    window.addEventListener('keydown', onKeyDown);
    return () => {
      window.removeEventListener('keydown', onKeyDown);
      document.body.style.overflow = previousOverflow;
    };
  }, [open]);

  if (!src) {
    return import.meta.env.DEV && pendingId ? (
      <div className="screenshot-pending" role="status">Screenshot pendente: {pendingId}</div>
    ) : null;
  }

  return (
    <figure className="help-image">
      <button type="button" className="help-image-trigger" onClick={() => setOpen(true)} aria-label={`Ampliar imagem: ${alt}`}>
        <img src={src} alt={alt} loading="lazy" />
      </button>
      {caption ? <figcaption>{caption}</figcaption> : null}

      {open ? (
        <div className="image-lightbox" role="dialog" aria-modal="true" aria-label={`Imagem ampliada: ${alt}`} onMouseDown={(event) => {
          if (event.currentTarget === event.target) setOpen(false);
        }}>
          <button ref={closeRef} type="button" className="lightbox-close" onClick={() => setOpen(false)} aria-label="Fechar imagem ampliada">×</button>
          <img src={src} alt={alt} />
        </div>
      ) : null}
    </figure>
  );
}
